<!--  -->
<template>
  <div class="main_w">
    <div class="v1">
      <template v-if="nickName">
        <span>你好，</span>
        <span>{{ nickName }}</span>
        <span v-if="canLogOut" @click="logOut">退出</span>
      </template>
      <span v-else @click="login">登录</span>
    </div>
    <div class="v2">3月28日-4月28日</div>
    <Swipe
      class="v3"
      :autoplay="3000"
      vertical
      :show-indicators="false"
      indicator-color="white"
    >
      <SwipeItem v-for="(item, index) in rollInfos" :key="index">
        <div class="v3_1">{{ item }}</div>
      </SwipeItem>
    </Swipe>
    <img src="~@/assets/images/ad/ad2/7.png" alt="" class="qiang" />
    <div class="v4">
      <img
        v-if="showDownLoad"
        src="~@/assets/images/ad/ad2/5.png"
        alt=""
        class="v4_1"
        @click="onDownload"
      />
      <img src="~@/assets/images/ad/ad2/6.png" alt="" class="share_bt" />
    </div>
    <div class="v5">
      <div v-if="!nickName || activityDrawNum > 0" class="v5_1">
        <p class="v5_1_t">机会×{{ nickName ? activityDrawNum : 1 }}</p>
        <img
          src="~@/assets/images/ad/ad2/1.png"
          alt=""
          class="v5_1_img"
          @click="onStartLuckyDraw"
        />
      </div>
      <img
        v-else-if="isCanShareAndOne === 1"
        src="~@/assets/images/ad/ad2/3.png"
        alt=""
        class="v5_2 share_bt"
      />
      <img
        v-else
        src="~@/assets/images/ad/ad2/4.png"
        alt=""
        class="v5_3"
        @click="login"
      />
    </div>
    <div class="v6">
      <span class="v6_t" @click="toDrawLogs">中奖记录</span>
    </div>
    <div class="v7">
      <div class="v7_1">活动规则</div>
      <p class="v7_2">1.本次活动仅面向神州邦邦平台注册用户。</p>
      <p class="v7_2">2.参与抢券活动，请确保账号处于登录状态并完成实名认证。</p>
      <p class="v7_2">
        3.活动期内所有完成认证的用户，均享有1次抢“现结券”机会。
      </p>
      <p class="v7_2">4.活动期内分享活动页面给好友，可额外增加1次抢券机会。</p>
      <p class="v7_2">
        5.“现结券”仅限本人使用，不可转赠，不可兑换现金，领取后60个自然日内有效。
      </p>
      <p class="v7_2">
        6.“现结券”每张仅可使用一次，限在线完成订单并申请提现时使用，1笔订单对应1张“现结券”，不支持多笔订单合并使用1张券，不支持1笔订单拆分使用多张券。
      </p>
      <p class="v7_2">
        7.“现结券”使用单笔订单金额须不超过1000元，否则无法享受“现结”权益。
      </p>
      <p class="v7_2">
        8.使用“现结券”发起提现，需满足订单服务完成并符合验收条件，确认符合验收条件时订单提现金额当日到账。
      </p>
      <p class="v7_2">9.本活动最终解释权归神州邦邦所有。</p>
    </div>
    <Overlay :show="isNotWin" z-index="100">
      <div class="notwin_wrapper" @click.stop>
        <div class="block">
          <div class="share_bt">
            分享<img
              src="~@/assets/images/ad/ad2/11.png"
              alt=""
              class="share_bt_1"
            />
          </div>
        </div>
        <Icon
          name="close"
          color="#fff"
          size="0.42rem"
          @click="isNotWin = false"
        />
      </div>
    </Overlay>
    <Overlay :show="isWin" z-index="100">
      <div class="win_wrapper" @click.stop>
        <div class="block">
          <div class="bt" @click="toUse">去使用</div>
        </div>
        <Icon name="close" color="#fff" size="0.42rem" @click="isWin = false" />
      </div>
    </Overlay>
  </div>
</template>

<script>
import { Swipe, SwipeItem, Toast, Divider, Overlay, Icon } from "vant";
import { get, toLogin, initLogin, post, logOut } from "@/utils/request3";
import { api, h5 } from "@/utils/env";
import wx from "@/assets/js/jweixin-1.6.0";
import {
  getWXEvn,
  isBangBangApp,
  isWeixin,
  initShare,
  navigateToApp,
} from "@/utils";
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {
    Swipe,
    SwipeItem,
    Divider,
    Overlay,
    Icon,
  },
  data() {
    //这里存放数据
    return {
      rollInfos: [],
      animate: false,
      nickName: "",
      activityPeriod: "",
      activityDrawNum: 0,
      canLogOut: false,
      isCanShareAndOne: 0,
      isWin: false,
      isNotWin: false,
      initShareObg: null,
      showDownLoad: true,
    };
  },
  //监听属性 类似于data概念
  computed: {},
  //监控data中的数据变化
  watch: {},
  //方法集合
  methods: {
    toDrawLogs() {
      this.$router.push({
        name: "drawLogs",
      });
    },
    login() {
      if (!this.nickName) {
        toLogin();
      } else if (this.isCanShareAndOne === 0 && this.activityDrawNum === 0) {
        Toast("很遗憾，您已没有抢券的机会");
      }
    },
    onStartLuckyDraw() {
      if (this.nickName) {
        post({
          url: api + "bangActivity/startLuckyDraw",
          data: {},
          requestType: 2,
        })
          .then((data) => {
            if (data.result === "success") {
              this.isNotWin = data.body.isWin === 0;
              this.isWin = data.body.isWin === 1;
              this.activityDrawNum = data.body.activityDrawNum;
              this.isCanShareAndOne = data.body.isCanShareAndOne;
              if (this.isCanShareAndOne === 1) {
                this.$nextTick(() => {
                  this.initShareObg.reBind();
                });
              }
            } else {
              Toast(data.message);
            }
          })
          .catch(() => {});
      } else {
        this.login();
      }
    },
    onDownload() {
      // location.href = `${h5}app/callApp.html`;
      location.href = `${h5}app/install.html?source=ENGINEER`;
    },
    toUse() {
      this.isWin = false;
      if (isBangBangApp()) {
        navigateToApp("szbb://weex/demand/demand-search-list.js");
      } else if (isWeixin()) {
        getWXEvn({
          //如果是小程序
          isMiniApp: () => {
            wx.miniProgram.navigateTo({
              url: "/subpackages/requirement/pages/search/search",
            });
          },
          //如果是公众号网页
          isWeixinNotMiniApp: () => {
            location.href = `${h5}app/install.html?source=ENGINEER`;
          },
        });
      } else {
        location.href = `${h5}app/install.html?source=ENGINEER`;
      }
    },
    logOut() {
      logOut();
      location.reload();
    },
  },
  //生命周期 - 创建完成（可以访问当前this实例）
  created() {
    if (isWeixin()) {
      getWXEvn({
        //如果是小程序
        isMiniApp: () => {
          this.canLogOut = false;
          this.showDownLoad = false;
        },
        //如果是公众号网页
        isWeixinNotMiniApp: () => {
          this.canLogOut = true;
        },
      });
    } else if (isBangBangApp()) {
      this.canLogOut = false;
      this.showDownLoad = false;
    } else {
      this.canLogOut = true;
    }
  },
  //生命周期 - 挂载完成（可以访问DOM元素）
  mounted() {
    this.initShareObg = new initShare({
      shareUrl: `${h5}app/v2/active/active2.html?utm_source=act20220325`,
      sharePath: "commonh5",
      imgUrl: require("@/assets/images/Output84.png"),
      miniAppImgUrl:
        "https://static.shenzhoubb.com/images/ad/popup/popup20220328.png",
      title: "10万现结订单，等你来抢",
      desc: "我分享了一张现结券给你，点击领取，快速提现",
      shareBtCb: () => {
        this.isNotWin = false;
        if (this.nickName) {
          post({
            url: api + "bangActivity/shareWithdrawActivity",
            data: {},
            requestType: 2,
          })
            .then((data) => {
              if (data.result === "success") {
                this.activityDrawNum = data.body.activityDrawNum;
                this.isCanShareAndOne = data.body.isCanShareAndOne;
              } else {
                Toast(data.message);
              }
            })
            .catch(() => {});
        }
      },
    });
    initLogin({
      success: () => {
        get({
          url: api + "bangActivity/withdrawDrawInfo",
          data: {},
          requestType: 2,
        })
          .then((data) => {
            if (data.result === "success") {
              this.rollInfos = data.body.rollInfos;
              this.nickName = data.body.nickName;
              this.activityPeriod = data.body.activityPeriod;
              this.activityDrawNum = data.body.activityDrawNum;
              this.isCanShareAndOne = data.body.isCanShareAndOne;
              this.$nextTick(() => {
                this.initShareObg.reBind();
              });
            } else {
              Toast(data.message);
            }
          })
          .catch(() => {});
      },
      fail: () => {
        get({
          url: api + "bangActivity/withdrawDrawInfo",
          data: {},
          requestType: 2,
        })
          .then((data) => {
            if (data.result === "success") {
              this.rollInfos = data.body.rollInfos;
              this.nickName = data.body.nickName;
              this.activityPeriod = data.body.activityPeriod;
              this.activityDrawNum = data.body.activityDrawNum;
              this.isCanShareAndOne = data.body.isCanShareAndOne;
              this.$nextTick(() => {
                this.initShareObg.reBind();
              });
            } else {
              Toast(data.message);
            }
          })
          .catch(() => {});
      },
    });
  },
  beforeCreate() {}, //生命周期 - 创建之前
  beforeMount() {}, //生命周期 - 挂载之前
  beforeUpdate() {}, //生命周期 - 更新之前
  updated() {}, //生命周期 - 更新之后
  beforeDestroy() {}, //生命周期 - 销毁之前
  destroyed() {}, //生命周期 - 销毁完成
  activated() {}, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>
<style lang='less' scoped>
//@import url(); 引入公共css类
.main_w {
  background: url(~@/assets/images/ad/ad2/8.png) no-repeat;
  width: 100%;
  background-size: cover;
  overflow: hidden;
  position: relative;
  padding-bottom: 1rem;
}
.qiang {
  position: absolute;
  width: 1.17rem;
  right: 1.5rem;
  top: 1.84rem;
  animation: zy 1s linear infinite;
}
.v1 {
  height: 0.3rem;
  font-size: 0.22rem;
  margin-top: 0.23rem;
  text-align: right;
  margin-right: 0.23rem;
  color: #ffd07b;
  font-weight: bolder;
}
.v2 {
  height: 0.3rem;
  font-size: 0.22rem;
  text-align: center;
  color: #fff;
}
.v3 {
  margin: 8.55rem auto 0;
  height: 0.4rem;
  width: 5.16rem;
  background: #ffdfa6;
  border-radius: 0.2rem;
  .v3_1 {
    font-size: 0.22rem;
    color: #f43821;
    line-height: 0.4rem;
    text-align: center;
  }
}
.v4 {
  position: absolute;
  top: 2rem;
  width: 1.5rem;
  right: -0.49rem;
  .v4_1,
  .share_bt {
    width: 1.5rem;
  }
  .share_bt {
    margin-top: -0.55rem;
  }
}
.v5 {
  width: 5.8rem;
  height: 3.66rem;
  background: url(~@/assets/images/ad/ad2/2.png) no-repeat;
  background-size: contain;
  margin: 0.91rem auto 0;
  position: relative;
  .v5_1 {
    width: 3.5rem;
    height: 2.43rem;
    position: absolute;
    left: 0;
    right: 0;
    top: -0.4rem;
    margin: auto;
    animation: heart 1s linear infinite;
    .v5_1_t {
      position: absolute;
      line-height: 0.3rem;
      top: 0;
      color: #fff;
      font-size: 0.28rem;
      text-align: center;
      width: 100%;
      margin-top: 0.3rem;
    }
    .v5_1_img {
      width: 3.5rem;
      height: 2.43rem;
    }
  }
  .v5_2 {
    width: 3.5rem;
    height: 2.43rem;
    position: absolute;
    left: 0;
    right: 0;
    top: -0.4rem;
    margin: auto;
    animation: heart 1s linear infinite;
  }
  .v5_3 {
    width: 3.5rem;
    height: 2.43rem;
    position: absolute;
    left: 0;
    right: 0;
    top: -0.4rem;
    margin: auto;
  }
}
.v6 {
  height: 0.3rem;
  text-align: center;
  line-height: 0.3rem;
  font-size: 0;
  margin-top: -1rem;
  position: relative;
  z-index: 10;
  .v6_t {
    font-size: 0.22rem;
    font-weight: bolder;
    color: #ff2400;
    text-decoration: underline;
  }
}
.v7 {
  width: 6.9rem;
  background: #ffffff;
  border-radius: 0.16rem;
  margin: 0 auto;
  overflow: hidden;
  margin-top: 0.4rem;
  box-sizing: border-box;
  padding: 0 0.4rem 0.4rem;
  .v7_1 {
    width: 1rem;
    font-size: 0.24rem;
    font-weight: bolder;
    color: #595353;
    margin: 0.2rem auto;
    position: relative;
    &::before {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto;
      left: -0.6rem;
      height: 0.01rem;
      width: 0.4rem;
      background: #d8d8d8;
    }
    &::after {
      content: "";
      display: block;
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto;
      right: -0.6rem;
      height: 0.01rem;
      width: 0.4rem;
      background: #d8d8d8;
    }
  }
  .v7_2 {
    font-size: 0.22rem;
    color: #948e8e;
    line-height: 0.32rem;
  }
}
.notwin_wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  flex-direction: column;
  .block {
    width: 3.71rem;
    height: 3.77rem;
    background: url(~@/assets/images/ad/ad2/10.png) no-repeat;
    background-size: contain;
    position: relative;
    margin-bottom: 0.5rem;
    .share_bt {
      font-size: 0.3rem;
      font-weight: bolder;
      color: #fb4529;
      text-align: center;
      line-height: 0.6rem;
      width: 2.6rem;
      border-radius: 0.3rem;
      background: #ffcd25;
      position: absolute;
      bottom: 0.3rem;
      left: 0;
      right: 0;
      margin: auto;
      .share_bt_1 {
        width: 0.7rem;
        height: 0.23rem;
        position: absolute;
        top: -0.28rem;
        right: -0.13rem;
      }
    }
  }
}
.win_wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  flex-direction: column;
  .block {
    width: 3.71rem;
    height: 3.77rem;
    background: url(~@/assets/images/ad/ad2/9.png) no-repeat;
    background-size: contain;
    position: relative;
    margin-bottom: 0.5rem;
    .bt {
      font-size: 0.3rem;
      font-weight: bolder;
      color: #fb4529;
      text-align: center;
      line-height: 0.6rem;
      width: 2.6rem;
      border-radius: 0.3rem;
      background: #ffcd25;
      position: absolute;
      bottom: 0.3rem;
      left: 0;
      right: 0;
      margin: auto;
    }
  }
}

@keyframes zy {
  0% {
    transform: rotate(15deg);
  }
  25% {
    transform: rotate(-10deg);
  }
  50% {
    transform: rotate(15deg);
  }
  75% {
    transform: rotate(-10deg);
  }
  100% {
    transform: rotate(15deg);
  }
}
@keyframes heart {
  0% {
    transform: scale(1, 1);
  }
  25% {
    transform: scale(1.1, 1.1);
  }
  100% {
    transform: scale(1, 1);
  }
}
</style>